import React from 'react';
import BaseCard from './BaseCard';
import ClockImg from '../../../assets/images/clock.svg';
import ArrivedImg from '../../../assets/images/car.svg';
import MissedImg from '../../../assets/images/square-x.svg';
import './TransportationCard.scss';

function TransportationCard({ graphData }) {
  const imgSources = {
    scheduled: ClockImg,
    arrived: ArrivedImg,
    missed: MissedImg,
  };

  const defaultTransportationData = [
    { status: 'scheduled', count: 0, percentage: '0%' },
    { status: 'arrived', count: 0, percentage: '0%' },
    { status: 'missed', count: 0, percentage: '0%' }
  ];

  const transportationData = graphData?.transportation || defaultTransportationData;
  const hasData = transportationData.some(item => item.count > 0);

  if (!hasData) {
    return (
      <BaseCard 
        title="Patient Transportation"
        className="transportation-card"
      >
        <div className="transportation-card__no-data">
          No Data
        </div>
      </BaseCard>
    );
  }

  return (
    <BaseCard 
      title="Patient Transportation"
      className="transportation-card"
    >
      <div className="transportation-card__content">
        <div className="transportation-card__graph">
          {transportationData.map((item, index) => (
            <div
              key={index}
              style={{ width: `${item?.percentage}` }}
              className="transportation-card__graph-item"
            >
              <div
                className={`transportation-card__graph-bar transportation-card__graph-bar--${item?.status?.toLowerCase()}`}
              >
                {item?.percentage}
              </div>
            </div>
          ))}
        </div>
        <ul className="transportation-card__list">
          {transportationData.map((item, index) => (
            <li key={index} className="transportation-card__list-item">
              <p className="transportation-card__status">
                <span className="transportation-card__icon">
                  <img
                    src={imgSources[item?.status]}
                    alt={item?.status}
                  />
                </span>
                <span className={`transportation-card__label transportation-card__label--${item?.status?.toLowerCase()}`}>
                  {item?.status}
                </span>
              </p>
              <p className="transportation-card__values">
                <span className="transportation-card__count">{item?.count}</span>
                <span className="transportation-card__percentage">{item?.percentage}</span>
              </p>
            </li>
          ))}
        </ul>
      </div>
    </BaseCard>
  );
}

export default React.memo(TransportationCard); 